export const Anchor = () => {
  $('.js-strategies').on("click","a", function (event) {
    event.preventDefault();
    $('.js-strategies a').removeClass('active');
    $(this).addClass('active');
    const id  = $(this).attr('href'), top = $(id).offset().top - 130;
    $('body,html').animate({scrollTop: top}, 1000);
  });
};